import React from "react";
import {useSiteMaintenanceInspectionTypesQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";

export const SiteMaintenanceInspectionSelect = (props) => {
    const query = useSiteMaintenanceInspectionTypesQuery();
    return <GraphQlSelect {...props} queryResult={query} labelField="label"/>;
}
